import { useMemo } from 'react';
import UISection from 'UIComponents/section/UISection';
import CallHighlightLabel from './CallHighlightLabel';
import CallHighlightTitle from './CallHighlightTitle';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import I18n from 'I18n';
import ReturnCallButtonWrapper from './return-call/components/ReturnCallButtonWrapper';
import { CALLING_PREVIEW_PANEL_CALLBACK } from 'calling-internal-common/constants/CallingGates';
import { CallDirection } from 'calling-internal-common/constants/CallDirection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallHighlightHeader = ({
  data,
  loading,
  error,
  gates = []
}) => {
  const callDetails = data && data.callDetails;
  const isUngatedForPreviewPanelCallback = useMemo(() => gates.includes(CALLING_PREVIEW_PANEL_CALLBACK), [gates]);
  if (loading) {
    return /*#__PURE__*/_jsx(UILoadingDots, {
      "data-test-id": "call-highlight-card-content-loading"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx("div", {
      className: "p-top-12 m-x-auto",
      children: /*#__PURE__*/_jsx(UIErrorMessage, {
        "data-test-id": "call-highlight-card-content-error",
        type: "error",
        title: I18n.text('call-highlight-card.error.title'),
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "call-highlight-card.error.errorMessage"
          })
        })
      })
    });
  }
  let callDirection = callDetails && callDetails.callDirection || '';
  const callTitle = callDetails && callDetails.callTitle || '';
  const calleeName = callDetails && callDetails.calleeName || '';
  const hasVoicemail = callDetails && callDetails.hasVoicemail || false;
  const callId = callDetails && callDetails.callId || undefined;
  const inboundCallOriginPhoneNumber = callDetails && callDetails.callFromNumber || '';
  const inboundCallDestinationPhoneNumber = callDetails && callDetails.callToNumber || '';
  callDirection = callDirection ? callDirection.charAt(0) + callDirection.substring(1).toLowerCase() : '';
  callDirection += ` ${hasVoicemail ? I18n.text('call-highlight-card.voicemail') : ''}`;
  return /*#__PURE__*/_jsx(UISection, {
    "data-selenium-test": "universal-sidebar-highlight",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CallHighlightTitle, {
        title: callTitle
      }), /*#__PURE__*/_jsx(CallHighlightLabel, {
        label: "call-highlight-card.callDirection",
        value: callDirection
      }), /*#__PURE__*/_jsx(CallHighlightLabel, {
        label: "call-highlight-card.callWith",
        value: calleeName
      }), isUngatedForPreviewPanelCallback && callDetails && callDetails.callDirection === CallDirection.INBOUND && /*#__PURE__*/_jsx("div", {
        className: "p-left-6 p-top-2",
        children: /*#__PURE__*/_jsx(ReturnCallButtonWrapper, {
          callId: callId,
          inboundCallDestinationPhoneNumber: inboundCallDestinationPhoneNumber,
          inboundCallOriginPhoneNumber: inboundCallOriginPhoneNumber
        })
      })]
    })
  });
};
export default CallHighlightHeader;